import React, { useRef, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { CredsContext, HelpModeContext } from "./Contexts";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import DashboardPanelHeader from "./DashboardPanelHeader";
import DashboardStyledMenu from "./styled components/DashboardStyledMenu";
import StatusProjectTeam from "./StatusProjectTeam";
import Tools from "./JNSTools";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Sort,
} from "@syncfusion/ej2-react-grids";
import {
  ComboBoxComponent,
  Inject,
  VirtualScroll,
} from "@syncfusion/ej2-react-dropdowns";
import { DataManager, Query } from "@syncfusion/ej2-data";
import "./styles/DashboardProjectTeam.css";

// user string structure:  First Last|Email|Role;
function DashboardProjectTeam(props) {
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const projectTeam = useRef(projectObject.oada_project_team__c);
  const [displayPage, setDisplayPage] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const creds = useContext(CredsContext).creds;
  //const setCreds = useContext(CredsContext).setCreds;
  const helpMode = useContext(HelpModeContext).mode;
  const grid = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const selectedUser = useRef();
  const newUser = useRef({
    teamFirstName: "",
    teamLastName: "",
    teamId: "",
    teamEmail: "",
    teamRole: "",
    teamPermission: "R",
  });
  const comboRef = useRef();
  const dbConfigStorage = sessionStorage.getItem("dashboardConfig");
  const dbConfig =
    dbConfigStorage && dbConfigStorage != "[]"
      ? JSON.parse(dbConfigStorage)
      : [];
  const panelInfo = dbConfig.find(
    (elem) => elem.id == "widget_" + props.panelId,
  );
  const panelHeight = panelInfo.sizeY;

  const urlString = Tools.getInstanceUrl(creds);
  const authString = Tools.getXmlBodyAuthString(creds);

  if (grid.current) {
    grid.current.getColumnByField("pic").disableHtmlEncode = false;
  }
  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleAdd = () => {
    selectedUser.current = null;
    setOpenDialog(true);
  };

  const handleOpen = (event) => {
    handleDotsClose();
    if (event.target.dataset.userinfo) {
      selectedUser.current = JSON.parse(event.target.dataset.userinfo);
    }
    loadDialogDefaults();
    setOpenDialog(true);
  };

  const handleConfirm = () => {
    handleClose();
    //if (newUser.current.id && !newUser.current.teamId) {
    if (newUser.current.id && newUser.current.id != newUser.current.teamId) {
      newUser.current.teamId = newUser.current.id;
    }
    if (newUser.current.teamId /*&& newUser.current.teamRole*/) {
      const userRequestString =
        authString +
        '<Read type="User" method="equal to" limit="1" enable_custom="1"><User><id>' +
        newUser.current.teamId +
        "</id></User></Read></request>";

      props.waitHandler(true);
      Tools.fetchPost(userRequestString, urlString, "User").then((userRec) => {
        const tempUserRec1 = userRec.xml[0];
        let genericEmail;
        for (const entry of tempUserRec1.childNodes.entries()) {
          if (entry[1].nodeName == "oada_user_email__c") {
            genericEmail = entry[1].textContent;
          }
          if (entry[1].nodeName == "addr") {
            for (const entry2 of entry[1].childNodes[0].childNodes.entries()) {
              if (entry2[1].nodeName == "email") {
                const semicolonIndex = entry2[1].textContent.indexOf(";");
                newUser.current.teamEmail =
                  semicolonIndex >= 0
                    ? entry2[1].textContent.substring(0, semicolonIndex)
                    : entry2[1].textContent;
              }
            }
          }
        }

        if (genericEmail) {
          newUser.current.teamEmail = genericEmail;
        }
        let newTeam;
        if (newUser.current.teamPermission == "undefined") {
          newUser.current.teamPermission = "R";
        }

        if (newUser.current.teamId == creds.id) {
          localStorage.setItem(
            "instanceInfo",
            Tools.encrypt(
              JSON.stringify({
                ...creds,
                projectRole: newUser.current.teamPermission,
              }),
            ),
          );
        }

        const newUserString =
          newUser.current.teamFirstName +
          " " +
          newUser.current.teamLastName +
          "|" +
          newUser.current.teamId +
          "|" +
          newUser.current.teamEmail +
          "|" +
          newUser.current.teamRole +
          "|" +
          newUser.current.teamPermission +
          "||" + // blank group
          newUser.current.statusReport;
        if (selectedUser.current) {
          const currentUserString =
            selectedUser.current.name.substring(
              0,
              selectedUser.current.name.indexOf(" "),
            ) +
            " " +
            selectedUser.current.name.substring(
              selectedUser.current.name.indexOf(" ") + 1,
            ) +
            "|" +
            selectedUser.current.id +
            "|" +
            selectedUser.current.email +
            "|" +
            selectedUser.current.role +
            "|" +
            selectedUser.current.permission +
            "|" +
            selectedUser.current.group +
            "|" +
            selectedUser.current.statusReport;
          newTeam = projectObject.oada_project_team__c.replace(
            currentUserString,
            newUserString,
          );

          selectedUser.current = null;
        } else {
          newTeam =
            projectObject.oada_project_team__c + newUserString + "|undefined;";
        }

        updateProjectTeam(newTeam);

        props.waitHandler(false);
      });
    }
  };

  const handleRemove = (event) => {
    //const userinfo = JSON.parse(event.target.dataset.userinfo);
    const userinfo = selectedUser.current;
    const userinfoString =
      userinfo.name +
      "|" +
      userinfo.id +
      "|" +
      userinfo.email +
      "|" +
      userinfo.role +
      "|" +
      userinfo.permission +
      "|" +
      userinfo.group +
      "|" +
      userinfo.statusReport +
      "|" +
      userinfo.lastView;
    const newTeam = projectTeam.current.replace(userinfoString + ";", "");

    // now remove user from project email subscription
    projectObject.oada_email_subscription__c =
      projectObject.oada_email_subscription__c.replace(
        "+" + userinfo.email,
        "",
      );
    projectObject.oada_email_subscription__c =
      projectObject.oada_email_subscription__c.replace(
        "-" + userinfo.email,
        "",
      );

    updateProjectTeam(newTeam);
    //handleDotsClose();
    handleClose();
  };

  function updateProjectTeam(newTeam) {
    projectObject.oada_project_team__c = newTeam;
    sessionStorage.setItem("projectObject", JSON.stringify(projectObject));
    projectTeam.current = newTeam;
    if (newTeam.length == 0) {
      newTeam = null;
    }

    const requestString =
      newTeam && newTeam.length > 0
        ? authString +
          '<Modify type="Project" enable_custom="1"><Project><id>' +
          projectObject.id +
          "</id><oada_project_team__c>" +
          newTeam +
          "</oada_project_team__c><oada_email_subscription__c>" +
          projectObject.oada_email_subscription__c +
          "</oada_email_subscription__c></Project></Modify></request>"
        : authString +
          '<Modify type="Project" method="custom equal to"><Project><id>' +
          projectObject.id +
          "</id><custom_field>oada_project_team</custom_field><value></value></Project></Modify></request>";

    Tools.fetchPost(requestString, urlString);
    //refreshDashboard();
  }

  const handleTextFieldValueChange = (event) => {
    const fieldname = event.target.id.substring(
      event.target.id.indexOf("_", event.target.id.indexOf("__") + 2) + 1,
    );
    newUser.current[fieldname] = event.target.value;
  };

  const handleCheckboxChange = (event) => {
    if (event.checked) {
      newUser.current.statusReport = "1";
    } else {
      newUser.current.statusReport = "";
    }
  };

  const handlePermissionClick = (event) => {
    const newPermission = event.target.value;
    if (newUser.current.teamPermission != newPermission) {
      newUser.current.teamPermission = newPermission;
      if (parseInt(newUser.current.teamId) == parseInt(creds.id)) {
        localStorage.setItem(
          "instanceInfo",
          Tools.encrypt(
            JSON.stringify({ ...creds, projectRole: newPermission }),
          ),
        );

        //projectObject.oada_project_team__c
        //setCreds({ ...creds, projectRole: newPermission });
        const teamArray = projectTeam.current.split(";"); // teamArray = array of single strings with name and email separated by a comma
        teamArray.pop(); // remove last element created because projectTeam.current ends with a semicolon
        let newTeamString = "";
        teamArray.forEach((elem) => {
          const teamMemberInfo = elem.split("|");

          if (newUser.current.teamId == teamMemberInfo[1]) {
            teamMemberInfo[4] = newPermission;
          }

          const newTeamMemberInfo = teamMemberInfo.join("|");
          newTeamString += newTeamMemberInfo + ";";
        });
        if (projectTeam.current != newTeamString) {
          projectTeam.current = newTeamString;
          projectObject.oada_project_team__c = projectTeam.current;
        }
      }
    }
  };
  const handleDropdownFieldValueChange = (event) => {
    newUser.current.id = event.itemData.id;
    newUser.current.teamFirstName = event.itemData.name
      .substring(event.itemData.name.indexOf(",") + 1)
      .trim();
    newUser.current.teamLastName = event.itemData.name.substring(
      0,
      event.itemData.name.indexOf(","),
    );
  };

  // don't delete this function.  It's not in use here but it could be useful elsewhere.
  function calculateColor(baseString) {
    let returnValue = "#";
    for (let i = 0; i < 3; i++) {
      const baseCharCode = baseString.toLowerCase().charCodeAt(i) - 97;
      const normalizedCode = parseInt((baseCharCode * 256) / 26);
      let hexVal = normalizedCode.toString(16);

      if (hexVal.length == 1) {
        hexVal = "0" + hexVal;
      }
      returnValue += hexVal;
    }
    return returnValue;
  }

  function calculateSimpleColor(baseString) {
    const colorArray = [
      "crimson",
      "darkred",
      "orangered",
      "rebeccapurple",
      "slateblue",
      "seagreen",
      "darkgreen",
      "darkcyan",
      "steelblue",
      "navy",
      "sienna",
      "slategray",
      "darkslategray",
    ];
    let returnValue = "black";
    let baseCharCode = baseString.toLowerCase().charCodeAt(0) - 97;
    if (baseCharCode >= 13) {
      baseCharCode -= 13;
    }

    returnValue = colorArray[baseCharCode];
    return returnValue;
  }

  const emailColumnTemplate = (props) => {
    return (
      <div>
        <a href={"mailto:" + props.email}>{props.email}</a>
      </div>
    );
  };

  const picColumnTemplate = (props) => {
    const src = "bxrul14g3m261.jpg";
    const showPic = false;
    let lastNameIndex = 0;
    while (props.name.trim().indexOf(" ", lastNameIndex) >= 0) {
      lastNameIndex = props.name.trim().indexOf(" ", lastNameIndex) + 1;
    }
    const initials = props.name[0] + props.name[lastNameIndex];

    const bgcolor = calculateSimpleColor(props.name);
    return showPic ? (
      <div className="image">
        <img src={src} height="40px" />
      </div>
    ) : (
      // asciirange of a-z is 97-122
      <Box
        sx={{
          height: "25px",
          width: "25px",
          backgroundColor: bgcolor,
          borderRadius: "25px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{ color: "white", fontSize: "smaller", fontWeight: "bold" }}
        >
          {initials}
        </Typography>
      </Box>
    );
  };

  const lastViewTemplate = (record) => {
    return record.lastView == "undefined" ? "" : record.lastView;
  };

  const dotsColumnTemplate = (props) => {
    return (
      <Box
        onClick={helpMode ? null : handleDotsClick}
        id={"__dashboardProjectTeamMenu_" + props.index}
        rowindex={props.index}
        sx={{
          height: "25px",
          width: "25px",
          //backgroundColor: "blue",
          color: "gray",
          borderRadius: "25px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          cursor: helpMode ? "help" : "pointer",
        }}
      >
        <MoreVertIcon rowindex={props.index} />
      </Box>
    );
  };

  const headerTemplate = (event) => {
    return (
      <span id="__dashboardProjectTeam_header" className="dashHeaderRow">
        {event.headerText}
      </span>
    );
  };

  const handleDotsClick = (event) => {
    const teamArray = projectTeam.current.split(";"); // teamArray = array of single strings with name and email separated by a comma
    teamArray.pop(); // remove last element created because projectTeam.current ends with a semicolon

    /*if (event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }*/
    //if (event.target.dataset.userinfo) {
    const userString =
      teamArray[
        event.currentTarget.id.substring(
          event.currentTarget.id.indexOf(
            "_",
            event.currentTarget.id.indexOf("__") + 2,
          ) + 1,
        )
      ];
    const teamMemberInfo = userString.split("|");

    const teamMemberObject = {
      name: teamMemberInfo[0].trim(),
      id: teamMemberInfo[1],
      email: teamMemberInfo[2],
      role: teamMemberInfo[3],
      permission: teamMemberInfo[4],
      group: teamMemberInfo[5],
      statusReport: teamMemberInfo[6],
      lastView: teamMemberInfo[7],
    };
    selectedUser.current = teamMemberObject;
    //}
    loadDialogDefaults();
    setOpenDialog(true);
  };

  const handleDotsClose = () => {
    setAnchorEl(null);
  };

  const openDotsMenu = Boolean(anchorEl);

  const loadDialogDefaults = () => {
    if (selectedUser.current) {
      newUser.current = {
        teamId: selectedUser.current.id,
        teamFirstName: selectedUser.current.name.substring(
          0,
          selectedUser.current.name.indexOf(" "),
        ),
        teamLastName: selectedUser.current.name.substring(
          selectedUser.current.name.indexOf(" ") + 1,
        ),
        teamEmail: selectedUser.current.email,
        teamRole: selectedUser.current.role,
        teamStatusReport: selectedUser.current.statusReport,
      };
    } else {
      newUser.current.id = undefined;
    }
  };

  // attempt at making combobox filter
  const origUserData = JSON.parse(
    localStorage.getItem(creds.company + "|User"),
  );
  const userData = [];
  origUserData.forEach((elem) => {
    if (elem.active == "1") {
      userData.push(elem);
    }
  });

  const filterUserData = new DataManager(userData);
  const userQuery = new Query().from("filterUserData").take(6);
  const userItemFields = { text: "name", value: "id" };
  function onFiltering(e) {
    if (e.text === "") {
      e.updateData(filterUserData);
    } else {
      // restrict the remote request until search key contains 3 characters.
      if (e.text.length < 3) {
        return;
      }
      let query = new Query().from("filterUserData").select(["name", "id"]);
      query =
        e.text !== "" ? query.where("name", "startswith", e.text, true) : query;
      e.updateData(filterUserData, query);
    }
  }

  const addPersonComponent = (
    <PersonAddIcon
      id="__dashboardProjectTeamAdd"
      onClick={helpMode ? null : handleAdd}
      fontSize="small"
      sx={{
        marginRight: "5px",
        cursor: helpMode ? "help" : "pointer",
      }}
    />
  );

  useEffect(() => {
    const teamArray = projectTeam.current.split(";"); // teamArray = array of single strings with name and email separated by a comma
    teamArray.pop(); // remove last element created because projectTeam.current ends with a semicolon

    const reqElem = document.getElementById("collabToolbar_Requirements");
    const raidElem = document.getElementById("collabToolbar_RAID");
    if (reqElem) {
      if (teamArray.length == 0) {
        reqElem.disabled = true;
      } else {
        reqElem.disabled = false;
      }
    }
    if (raidElem) {
      if (teamArray.length == 0) {
        raidElem.disabled = true;
      } else {
        raidElem.disabled = false;
      }
    }

    const dataArray = [];

    let newTeamString = "";
    teamArray.forEach((elem) => {
      const teamMemberInfo = elem.split("|");

      //if (teamMemberInfo.length == 6) {
      if (creds.id == teamMemberInfo[1]) {
        //teamMemberInfo.push(new Date().toISOString().substring(0, 10));
        teamMemberInfo[7] = new Date().toISOString().substring(0, 10);
        //} else {
        //  teamMemberInfo.push(""); // populate lastView if empty
      }

      const newTeamMemberInfo = teamMemberInfo.join("|");
      newTeamString += newTeamMemberInfo + ";";
      //}
      const teamMemberObject = {
        name: teamMemberInfo[0].trim(),
        id: teamMemberInfo[1],
        email: teamMemberInfo[2],
        role: teamMemberInfo[3],
        permission: teamMemberInfo[4],
        group: teamMemberInfo[5],
        statusReport: teamMemberInfo[6],
        lastView: teamMemberInfo[7],
      };
      dataArray.push(teamMemberObject);
    });

    /*
    
    This code seems necessary, but breaks things
    
    if (projectTeam.current != newTeamString) {
      projectTeam.current = newTeamString;
      projectObject.oada_project_team__c = projectTeam.current;
    }*/

    const prepDisplayPage = props.statusVersion ? (
      <Box>
        <StatusProjectTeam dataArray={dataArray} />
      </Box>
    ) : (
      <>
        <Box
          height={12 / panelHeight + "%"}
          className="dashTableTitleBar"
          id="__dashboardProjectTeam"
          sx={{ cursor: helpMode ? "help" : "default" }}
        >
          <DashboardPanelHeader
            panelLocked={props.panelLocked}
            title="Project Team"
            removePanel={props.removePanel}
            panelId={props.panelId}
            headerComponent={addPersonComponent}
          />
        </Box>
        <Box
          height="85%"
          id="__dashboardProjectTeam"
          sx={{
            overflow: "auto",
            verticalAlign: "middle",
            border: "solid 2px",
            padding: "0px 4px 4px 4px",
            borderRadius: "0px 0px 6px 6px",
            backgroundColor: "white",
            cursor: helpMode ? "help" : "default",
          }}
        >
          <GridComponent
            className="gridWithSmallHeader"
            enableStickyHeader={true}
            dataSource={dataArray}
            ref={(g) => (grid.current = g)}
            allowSorting={true}
          >
            <Inject services={[Sort]} />
            <ColumnsDirective>
              <ColumnDirective
                field="pic"
                width="35"
                headerText=""
                textAlign="Left"
                template={picColumnTemplate}
                headerTemplate={headerTemplate}
                customAttributes={{ class: "projectTeamPicCell" }}
              />
              <ColumnDirective
                field="name"
                headerText="Name"
                textAlign="Left"
                headerTemplate={headerTemplate}
                customAttributes={{ class: "projectTeamNameCell" }}
              />
              <ColumnDirective
                field="email"
                headerText="Email"
                textAlign="Left"
                template={emailColumnTemplate}
                headerTemplate={headerTemplate}
                customAttributes={{ class: "projectTeamEmailCell" }}
              />
              {props.includeRole ? (
                <ColumnDirective
                  field="role"
                  headerText="Role"
                  textAlign="Left"
                  headerTemplate={headerTemplate}
                  customAttributes={{ class: "projectTeamEmailCell" }}
                />
              ) : null}
              {props.includeLastView ? (
                <ColumnDirective
                  field="lastView"
                  headerText="Last Viewed"
                  textAlign="Left"
                  headerTemplate={headerTemplate}
                  template={lastViewTemplate}
                  customAttributes={{ class: "projectTeamEmailCell" }}
                />
              ) : null}
              <ColumnDirective
                field="dots"
                width="25"
                headerText=""
                textAlign="Right"
                template={dotsColumnTemplate}
                headerTemplate={headerTemplate}
                customAttributes={{ class: "projectTeamDotsCell" }}
              />
            </ColumnsDirective>
          </GridComponent>
        </Box>
        <Dialog open={openDialog} onClose={handleClose}>
          <Box
            sx={{
              backgroundColor: "gainsboro",
              padding: "10px",
              border: "solid 2px",
              width: "500px",
            }}
          >
            <Typography
              sx={{
                fontSize: "large",
                backgroundColor: "#643f69",
                color: "white",
                borderRadius: "5px",
                paddingLeft: "5px",
                marginBottom: "15px",
              }}
            >
              Team Member
            </Typography>

            <Box className="dashComboBox" display="inline-block">
              <ComboBoxComponent
                id="userCombo"
                ref={(combo) => (comboRef.current = combo)}
                dataSource={userData}
                fields={userItemFields}
                enableVirtualization={userData.length > 100 ? true : false}
                width="80%"
                placeholder="Select user..."
                cssClass="dashComboBox"
                select={handleDropdownFieldValueChange}
                value={
                  selectedUser.current
                    ? userData.find(
                        (elem) => elem.id == selectedUser.current.id,
                      ).name
                    : null
                }
                //allowFiltering={true}
                //filtering={onFiltering}
                //query={userQuery}
              >
                <Inject services={[VirtualScroll]} />
              </ComboBoxComponent>
            </Box>
            <TextField
              id="__dashboardProjectTeamRole_teamRole"
              defaultValue={
                selectedUser.current ? selectedUser.current.role : null
              }
              onChange={handleTextFieldValueChange}
              variant="standard"
              label="Role"
              sx={{ margin: "0px 20px 0px 20px", width: "200px" }}
            ></TextField>

            <Box
              sx={{
                margin: "20px",
                textAlign: "center",
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Box width="50%">
                <RadioGroup
                  name="radio-buttons-group"
                  defaultValue={
                    selectedUser.current
                      ? selectedUser.current.permission == "F" ||
                        selectedUser.current.permission == "O"
                        ? selectedUser.current.permission
                        : "R"
                      : "R"
                  }
                >
                  <FormControlLabel
                    value="F"
                    id="__dashboardProjectTeamFullAccess"
                    onClick={handlePermissionClick}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          marginLeft: "20px",
                        }}
                      />
                    }
                    label="Full access"
                  />
                  <FormControlLabel
                    value="O"
                    id="__dashboardProjectTeamOwnedAccess"
                    onClick={handlePermissionClick}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          marginLeft: "20px",
                        }}
                      />
                    }
                    label="Owned entity access"
                  />
                  <FormControlLabel
                    value="R"
                    onClick={handlePermissionClick}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          marginLeft: "20px",
                        }}
                      />
                    }
                    label="Read access"
                  />
                </RadioGroup>
              </Box>

              <Box width="50%">
                <CheckBoxComponent
                  label="Receive Status Reports"
                  change={handleCheckboxChange}
                  checked={
                    selectedUser.current
                      ? selectedUser.current.statusReport == "1"
                      : null
                  }
                />
              </Box>
            </Box>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                className="dialogConfirmCancelButton"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="dialogConfirmCancelButton"
                onClick={handleConfirm}
              >
                Save
              </Button>
              {selectedUser.current ? (
                <Button className="dialogDeleteButton" onClick={handleRemove}>
                  Remove
                </Button>
              ) : null}
            </DialogActions>
          </Box>
        </Dialog>

        <DashboardStyledMenu
          id="dotsMenu"
          open={openDotsMenu}
          anchorEl={anchorEl}
          onClose={handleDotsClose}
        >
          <MenuItem
            data-userinfo={
              anchorEl
                ? JSON.stringify(
                    dataArray[
                      anchorEl.id.substring(
                        anchorEl.id.indexOf(
                          "_",
                          anchorEl.id.indexOf("__") + 2,
                        ) + 1,
                      )
                    ],
                  )
                : null
            }
            onClick={handleOpen}
          >
            Edit Team Member
          </MenuItem>
          <MenuItem
            data-userinfo={
              anchorEl
                ? JSON.stringify(
                    dataArray[
                      anchorEl.id.substring(
                        anchorEl.id.indexOf(
                          "_",
                          anchorEl.id.indexOf("__") + 2,
                        ) + 1,
                      )
                    ],
                  )
                : null
            }
            onClick={handleRemove}
          >
            Remove from Team
          </MenuItem>
        </DashboardStyledMenu>
      </>
    );
    setDisplayPage(prepDisplayPage);
  }, [openDialog, openDotsMenu, projectTeam.current, helpMode]);

  return displayPage;
}

export default DashboardProjectTeam;

DashboardProjectTeam.propTypes = {
  refreshDashboard: PropTypes.func,
  satusVersion: PropTypes.bool,
};
/*
              <CheckBoxComponent
                id="__dashboardProjectTeamFullAccess"
                label="Full access"
                checked={
                  selectedUser.current
                    ? selectedUser.current.permission == "F"
                    : false
                }
                change={handleCheckboxChange}
              />
              &nbsp;&nbsp;
              <CheckBoxComponent
                id="__dashboardProjectTeamOwnedAccess"
                label="Owned entity access"
                checked={
                  selectedUser.current
                    ? selectedUser.current.permission != "R"
                    : false
                }
                change={handleCheckboxChange}
              />
              */

/*
           <TextField
              required
              id="teamFirstName"
              defaultValue={
                selectedUser.current
                  ? selectedUser.current.name.substring(
                      0,
                      selectedUser.current.name.indexOf(" "),
                    )
                  : null
              }
              onChange={handleTextFieldValueChange}
              variant="standard"
              label="First Name"
              sx={{ margin: "0px 10px", width: "200px" }}
            ></TextField>
            <TextField
              required
              id="teamLastName"
              defaultValue={
                selectedUser.current
                  ? selectedUser.current.name.substring(
                      selectedUser.current.name.indexOf(" ") + 1,
                    )
                  : null
              }
              onChange={handleTextFieldValueChange}
              variant="standard"
              label="Last Name"
              sx={{ margin: "0px 10px", width: "200px" }}
            ></TextField>
            <br></br>
            <TextField
              required
              id="teamEmail"
              defaultValue={
                selectedUser.current ? selectedUser.current.email : null
              }
              onChange={handleTextFieldValueChange}
              variant="standard"
              label="E-mail"
              sx={{ margin: "0px 10px", width: "200px" }}
            ></TextField>
*/
